
import CustomerShow from '../components/customers/CustomerShow.vue';
import Vue from 'vue';

Vue.component('customer-show', CustomerShow);

export default Vue.extend({});
